import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, isHex, isU8a, u8aToHex, u8aToU8a } from '@polkadot/util';
import { decodeAddress } from '@polkadot/util-crypto';

var _map = /*#__PURE__*/new WeakMap();

export var Pairs = /*#__PURE__*/function () {
  function Pairs() {
    _classCallCheck(this, Pairs);

    _classPrivateFieldInitSpec(this, _map, {
      writable: true,
      value: {}
    });
  }

  _createClass(Pairs, [{
    key: "add",
    value: function add(pair) {
      _classPrivateFieldGet(this, _map)[decodeAddress(pair.address).toString()] = pair;
      return pair;
    }
  }, {
    key: "all",
    value: function all() {
      return Object.values(_classPrivateFieldGet(this, _map));
    }
  }, {
    key: "get",
    value: function get(address) {
      var pair = _classPrivateFieldGet(this, _map)[decodeAddress(address).toString()];

      assert(pair, function () {
        return "Unable to retrieve keypair '".concat(isU8a(address) || isHex(address) ? u8aToHex(u8aToU8a(address)) : address, "'");
      });
      return pair;
    }
  }, {
    key: "remove",
    value: function remove(address) {
      delete _classPrivateFieldGet(this, _map)[decodeAddress(address).toString()];
    }
  }]);

  return Pairs;
}();